const trains = {
  train: "Τρένο", // translated
  trains: "τρένα", // translated
  fairConditions: "Δίκαιες συνθήκες", // translated
  to: "προς την", // translated
  earlier: "Νωρίτερα", // translated
  later: "Αργότερα", // translated
  adults: "Ενήλικες", // translated
  child: "Παιδί", // translated
  senior: "Αρχαιότερος", // translated
  seniors: "Ηλικιωμένοι", // translated
  price: "Τιμή", // translated
  for: "Για", // translated
  total: "Σύνολο", // translated
  selected: "Επιλεγμένο", // translated
  prebook: "Προβιβλίο", // translated
  book: "Βιβλίο", // translated
  payment: "Πληρωμή", // translated
  return: "ΕΠΙΣΤΡΟΦΗ", // translated
  passengers: "Επιβάτες", // translated
  delivery: "Διανομή", // translated
  summary: "Περίληψη", // translated
  checkout: "Ολοκλήρωση αγοράς", // translated
  trainToastCorrectFillForm: "Παρακαλούμε συμπληρώστε σωστά όλα τα πεδία.", // translated
  fareConditions: "Προϋποθέσεις ναύλων", // translated
  travelInfo: "Πληροφορίες ταξιδιού", // translated
  remarks: "Παρατηρήσεις πελατών", // translated
  noServices: "Δεν υπάρχουν υπηρεσίες", // translated
  timesAndSeats: "Ώρες και θέσεις", // translated
  mobileTicket: "Εισιτήριο για κινητό", // translated
  stationTicket: "Συλλέξτε στο σταθμό", // translated
  homeTicket: "Εκτύπωση στο σπίτι", // translated
  countryCode: "Κωδικός χώρας", // translated
  chooseTicket: "Επιλέξτε τρόπο παράδοσης εισιτηρίου", // translated
  ticketError: "Επιλέξτε ένα εισιτήριο για όλους τους προορισμούς", // translated
  ticketDelivery: "Επιλέξτε τρόπο παράδοσης εισιτηρίου", // translated
  passengerDetails: "Στοιχεία επιβάτη", // translated
  waitWhileProcessingPayment: "Περιμένετε μέχρι να επεξεργαστούμε την πληρωμή σας, μην ανανεώσετε ή κλείσετε τη σελίδα.", // translated
  reductionCardId: "Ταυτότητα κάρτας μείωσης", // translated
  countryOfResidence: "Χώρα κατοικίας", // translated
  countryOfBirth: "Χώρα γέννησης", // translated
  documentCountry: "Χώρα εγγράφου", // translated
  documentNumber: "Αριθμός Εγγράφου", // translated
  expirationDate: "Ημερομηνία λήξης", // translated
  documentType: "Είδος αρχείου", // translated
  travelerDocumentInfo: "Πληροφορίες ταξιδιωτικού εγγράφου", // translated
  youth: "Νεολαία", // translated
  youths: "Νεαροί", // translated
  departTimeEarlyFirst: "Ώρα αναχώρησης (πρώτα το νωρίτερο)", // translated
};

export default trains;
